<ion-grid class="info-grid-v2">
    <ion-row>
        <ion-col size="12">
            <ion-label>
                {{ 'label.mfa_description' | translate }}
            </ion-label>
        </ion-col>
    </ion-row>

    <!-- Phone Number MFA method -->
    <ion-row class="mfa-method-row">
        <ion-col size="12" size-sm="8">
            <div class="mfa-method-label">
                <div>
                    <strong>{{ 'label.mfa_method_phone' | translate }}</strong>
                    <p class="mfa-method-desc">{{ 'label.mfa_phone_description' | translate }}</p>
                </div>
            </div>
        </ion-col>
        <ion-col size="12" size-sm="4" class="toggle-container">
            <mat-slide-toggle
                #phoneToggle
                [checked]="phoneEnabled"
                (change)="togglePhone($event)"
                [disabled]="phoneLoading"
                class="custom-slide-toggle"></mat-slide-toggle>
        </ion-col>
    </ion-row>

    <!-- Email MFA method -->
    <ion-row class="mfa-method-row">
        <ion-col size="12" size-sm="8">
            <div class="mfa-method-label">
                <div>
                    <strong>{{ 'label.mfa_method_email' | translate }}</strong>
                    <p class="mfa-method-desc">{{ 'label.mfa_email_description' | translate }}</p>
                </div>
            </div>
        </ion-col>
        <ion-col size="12" size-sm="4" class="toggle-container">
            <mat-slide-toggle
                #emailToggle
                [checked]="emailEnabled"
                (change)="toggleEmail($event)"
                [disabled]="emailLoading"
                class="custom-slide-toggle"></mat-slide-toggle>
        </ion-col>
    </ion-row>
</ion-grid>
